
export const validateInputs = (inputs) => {
    let isError = false;
    let errorMessage = "";
    let count = 0;

    inputs.forEach(input => {
        // Если это числовое поле и оно не пустое
        if (input.type === 'number' && !input.value) {
            // Если поле необязательное — пропускаем
            if (input.required === false) {
                input.isError = false;
                return;
            }
            input.isError = true;
            errorMessage = input.error || "Поле обязательно для заполнения";
            isError = true;
            count++;
            return; // переходим к следующему input
        }

        if (input.type === 'number') {
            return; // переходим к следующему input
        }

        // 1️⃣ Проверяем на пустое значение
        if (!input.value || input.value.trim().length === 0) {
            if (input.required === false) {
                input.isError = false;
                return;
            }
            input.isError = true;
            errorMessage = input.error || "Поле обязательно для заполнения";
            isError = true;
            count++;
            return; // переходим к следующему input
        }

        // 2️⃣ Проверка маски телефона
        if (input.activeMask === "phone") {
            // убираем всё кроме цифр
            const digits = input.value.replace(/\D/g, "");
            // для России правильная длина — 11 цифр (+7 и ещё 10)
            if (digits.length !== 11) {
                input.isError = true;
                errorMessage = "Введите корректный номер телефона";
                isError = true;
                return;
            }
        }

        if (input.activeMask === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(input.value)) {
                input.isError = true;
                errorMessage = "Введите корректную почту";
                isError = true;
                return;
            }
        }

        // 3️⃣ Проверка username — только если задана активная маска
        if (input.activeMask === "username") {
            if (!/^@[a-zA-Z0-9_]+$/.test(input.value)) {
                input.isError = true;
                errorMessage = "Имя пользователя может содержать только латиницу, цифры и _";
                isError = true;
                return;
            }
        }

        // 4️⃣ Если ошибок нет — снимаем флаг
        input.isError = false;
    });

    // 5️⃣ Если несколько пустых полей
    if (count > 1) {
        isError = true;
        errorMessage = "Необходимо заполнить все поля";
    }

    return { isError, errorMessage };
};

// export const validateInputs = (inputs) => {
//     let isError = false;
//     let errorMessage = "";
//     let count = 0;

//     inputs.forEach(input => {
//         if (input.value.length === 0) {
//             input.isError = true;
//             errorMessage = input.error;
//             isError = true;
//             count++;
//         } else {
//             input.isError = false;
//         }
//     });

//     if (count > 1) {
//         isError = true;
//         errorMessage = "Необходимо заполнить все поля";
//     }

//     return { isError, errorMessage };
// }

export const validateInputsArray = (inputsArray) => {
    let isError = false;
    let errorMessage = "";
    let count = 0;

    inputsArray.forEach(inputs => {
        inputs.forEach(input => {
            if (input.value === undefined) {
                input.isError = true;
                errorMessage = input.error;
                isError = true;
                count++;
            } else if (input.value.length === 0) {
                input.isError = true;
                errorMessage = input.error;
                isError = true;
                count++;
            } else {
                input.isError = false;
            }
        });

        if (count > 1) {
            isError = true;
            errorMessage = "Необходимо заполнить все поля";
        }
    });

    return { isError, errorMessage };
}

export const clearInputsErrors = (inputs) => {
    inputs.forEach(input => {
        input.isError = false;
    });
}

export const clearInputsValues = (inputs) => {
    inputs.forEach(input => {
        input.value = "";
    });
}

export const getInputValueByName = (inputs, name) => {
    const input = inputs.find(input => input.name === name);
    return input.value;
}

export const getInputById = (inputs, id) => {
    const input = inputs.find(input => input.id === id);
    return input;
}

export default { validateInputs, clearInputsErrors, clearInputsValues, getInputValueByName, validateInputsArray, getInputById };
